import { AnalyticsEventName } from './constants';
import { trackEvent } from './utils';

export interface NonPromoEvent {
  block_name?: string;
  block_type?: string;
  block_id?: string;
}

export const trackViewBannerEvent = (nonPromo: NonPromoEvent) => {
  if (nonPromo) {
    trackEvent({
      eventName: AnalyticsEventName.ViewBanner,
      parameters: {
        block_name: nonPromo.block_name ?? '',
        block_type: nonPromo.block_type ?? '',
        block_id: nonPromo.block_id ?? ''
      }
    });
  }
};

export const trackSelectBannerEvent = (nonPromo: NonPromoEvent) => {
  if (nonPromo) {
    trackEvent({
      eventName: AnalyticsEventName.SelectBanner,
      parameters: {
        block_name: nonPromo.block_name ?? '',
        block_type: nonPromo.block_type ?? '',
        block_id: nonPromo.block_id ?? ''
      }
    });
  }
};
